import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import configureStore from './store/configureStore';
import Routes from './router/Routes';
import history from './history';
import './styles/helpers/global-styles';
import rootSaga from './sagas';

const store = configureStore();
store.runSaga(rootSaga);

function main() {
  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <Routes />
      </Router>
    </Provider>,
    document.getElementById('react_root')
  );
}

main();



// WEBPACK FOOTER //
// ./src/index.js